import { apiClient } from './api';
import {
  DocumentTemplate,
  DocumentTemplateFilters,
  DocumentTemplateUploadData,
} from '../types/documentTemplate';

export class DocumentTemplateService {
  async getTemplates(filters?: DocumentTemplateFilters) {
    return apiClient.getDocumentTemplates(filters);
  }

  async getTemplateById(id: string) {
    return apiClient.getDocumentTemplateById(id);
  }

  async createTemplate(data: DocumentTemplateUploadData) {
    const formData = new FormData();
    formData.append('name', data.name);
    if (data.description) {
      formData.append('description', data.description);
    }
    formData.append('type', data.type);
    formData.append('tags', JSON.stringify(data.tags));
    formData.append('file', data.file);

    return apiClient.createDocumentTemplate(formData);
  }

  async updateTemplate(id: string, data: Partial<DocumentTemplate>) {
    return apiClient.updateDocumentTemplate(id, data);
  }

  async deleteTemplate(id: string) {
    return apiClient.deleteDocumentTemplate(id);
  }

  async uploadNewVersion(id: string, file: File, version: string) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('version', version);

    return apiClient.uploadDocumentTemplateVersion(id, formData);
  }

  async downloadTemplate(id: string, fileName?: string) {
    const { blob, filename } = await apiClient.downloadDocumentTemplate(id);
    this.downloadFile(blob, fileName || filename);
  }

  async getTemplateStats(id: string) {
    return apiClient.getDocumentTemplateStats(id);
  }

  async getTemplateTypes() {
    return apiClient.getDocumentTemplateTypes();
  }

  private downloadFile(blob: Blob, fileName: string) {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  }
}

export const documentTemplateService = new DocumentTemplateService(); 